import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { change, formValueSelector } from 'redux-form'
import { TextInput } from 'SRC/ui/FormElements'
import { getPriceTypes } from 'SRC/modules/users/Profile/selectors'
import { priceMask } from 'Core/masks'
import { ReduxFormRequired } from 'Core/validators/reduxForm'

class AuctionPrice extends React.Component {
  componentDidUpdate () {
    const { priceMasked } = this.props
    this.props.change(this.props.formName, 'priceUnmasked', priceMasked.toString().replace(',', '.'))
  }

  shouldComponentUpdate (nextProps) {
    return nextProps.priceMasked && this.props.priceMasked !== nextProps.priceMasked
  }
  render () {
    const { priceType } = this.props

    return [<TextInput
      id='price'
      label={priceType ? priceType.priceName : 'Cijena'}
      isRequired
      name='price'
      measure='€'
      mask={priceMask}
      validate={ReduxFormRequired}
    />, <input id='priceUnmasked' type='hidden' name='priceUnmasked' />]
  }
}

const mapStateToProps = (state, ownProps) => {
  const selector = formValueSelector(ownProps.formName)

  const priceTypes = getPriceTypes(state)

  const priceType = Array.isArray(priceTypes) ? priceTypes.find(pt => pt.name === 'Aukcija') : null

  return {
    priceMasked: selector(state, 'price'),
    priceType
  }
}

AuctionPrice.propTypes = {
  priceMasked: PropTypes.string.isRequired,
  formName: PropTypes.string.isRequired,
  priceType: PropTypes.object,
  change: PropTypes.func.isRequired
}

AuctionPrice.defaultProps = {
  priceMasked: ''
}

export default connect(mapStateToProps, {change})(AuctionPrice)
